import { transformUser } from '../user/user.reducer';
import { mergeEntity, ObjectReducer } from '../store';
import { OnlineOfflineStatus } from './online-offline.model';

export const onlineOfflineReducer: ObjectReducer<'onlineOffline'> = (state = {}, action) => {

  switch (action.type) {
    case 'WS_MESSAGE':
      if (action.payload.type === 'ONLINE_OFFLINE') {
        const data = action.payload.data;
        return mergeEntity(
          state,
          data,
          ['onlineOffline', data.userId],
        );
      }
      return state;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/online-offline/online-offline.reducer.ts